import React, { Fragment, useState } from "react";
import { Card } from "antd";
import { tabList } from "../Mantenedores/tabList";
import { useGetFormulario } from "../../../Hooks/Admin";

export const Administrar = () => {
  const [activeTabKey, setActiveTabKey] = useState("Logros");
  const formularioHook = useGetFormulario({ key: activeTabKey });

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };

  return (
    <Fragment>
      <Card
        style={{
          width: "100%",
        }}
        tabList={tabList}
        activeTabKey={activeTabKey}
        onTabChange={onTabChange}
        tabProps={{
          size: "small",
        }}
      >
        {activeTabKey && formularioHook}
      </Card>
    </Fragment>
  );
};
